import {
    Table,
    TableCaption,
    TableContainer,
    Tbody,
    Td,
    Th,
    Thead,
    Tr
} from '@chakra-ui/react'
import dayjs from 'dayjs'
import Pagination from '../../../../components/Pagination'
import { TableMovementsProps } from './types'

export default function TableMovements({
    onLimit,
    onPage,
    itemMovements,
    page,
    limit,
    pages
}: TableMovementsProps) {
    const getReason = (type_movement: number) => {
        switch (type_movement) {
            case 1:
                return 'Venta'
            case 2:
                return 'Anulación de venta'
            case 3:
                return 'Aumento de stock'
            case 4:
                return 'Decremento de stock'
        }
    }
    return (
        <>
            <TableContainer>
                <Table size="sm" className="table-a-la-orden">
                    <Thead>
                        <Tr>
                            <Th>Fecha y Hora</Th>
                            <Th>Operación</Th>
                            <Th>Usuario</Th>
                            <Th>Unidad</Th>
                            <Th>Costo unitario</Th>
                            <Th>Stock Inicial</Th>
                            <Th>Ajuste</Th>
                            <Th>Stock final</Th>
                            <Th>Motivo</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {itemMovements.map(itemMovement => (
                            <Tr key={itemMovement.id}>
                                <Td>
                                    {dayjs(itemMovement.created_at).format(
                                        'DD/MM/YYYY hh:mm a'
                                    )}
                                </Td>
                                <Td
                                    style={{
                                        textAlign: 'left'
                                    }}
                                >
                                    {getReason(itemMovement.type_movement)}
                                </Td>
                                <Td>
                                    {itemMovement.user
                                        ? `${itemMovement.user.firstname} ${itemMovement.user.lastname}`
                                        : ''}
                                </Td>

                                <Td>
                                    {
                                        itemMovement?.production_item_warehouse
                                            ?.production_item?.magnitude?.name
                                    }
                                </Td>
                                <Td>{itemMovement.cost}</Td>
                                <Td>{itemMovement.initial_quantity}</Td>
                                <Td>{itemMovement.marginal_quantity}</Td>
                                <Td>{itemMovement.current_quantity}</Td>
                                <Td
                                    style={{
                                        textAlign: 'left'
                                    }}
                                >
                                    {itemMovement.reason}
                                </Td>
                            </Tr>
                        ))}
                    </Tbody>
                    {itemMovements.length === 0 && (
                        <TableCaption>No existen movimientos</TableCaption>
                    )}
                </Table>
            </TableContainer>
            <Pagination
                pages={pages}
                page={page}
                limit={limit}
                onLimit={onLimit}
                onPage={onPage}
            />
        </>
    )
}
